import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

const Navbar7 = ({ backPath, projectId, title = "Build Flow" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(backPath, { state: { projectId } });
  };

  return (
    <nav className="flex items-center justify-between p-6 border-b">
      <div className="text-2xl font-bold text-black">{title}</div>
      <button
        onClick={handleBack}
        className="text-gray-600 hover:text-black transition-colors duration-200"
      >
        <XCircle size={24} />
      </button>
    </nav>
  );
};

export default Navbar7;